import React, { useState, useRef, useEffect } from "react";
import { CgProfile } from "react-icons/cg";
import {
  FaSignOutAlt,
  FaBars,
  FaChevronDown,
  FaRegListAlt,
} from "react-icons/fa";
import { LuLayoutDashboard } from "react-icons/lu";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { IoCloseSharp } from "react-icons/io5";
import {
  COLLECTION_ROUTE,
  DASHBOARD_ROUTE,
  LOGIN_ROUTE,
  OREDR_ROUTE,
  PRODUCTS_ROUTE,
  PROFILE_ROUTE,
} from "../../routes/web/rootRoutes";
import useClickAway from "../../hooks/ui/useClickAway";
import PartnerAuth from "../../middleware/PartnerAuth";
import { useDispatch, useSelector } from "react-redux";
import apiRequest from "../../utils/apiRequest";
import {
  resetUserProfile,
  setUserProfile,
} from "../../store/slice/globalStore";
import authManager from "../../utils/authManager";
import Loader from "../ui/loader/Loader";
import { getFileUrl } from "../../utils/helper";
import { GrOrderedList } from "react-icons/gr";

const Layout = ({ children }) => {
  const setting = useSelector((state) => state.globalState.siteSetting);
  const BRAND_NAME = useSelector(
    (state) => state.globalState?.siteSetting?.site_settings?.site_name
  );

  const LOGO = getFileUrl(setting?.site_settings?.site_logo);
  const [isMobileSidebarOpen, setIsMobileSidebarOpen] = useState(false);
  const [activeMenu, setActiveMenu] = useState(null);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const userProfile = useSelector((state) => state.globalState.userProfile);
  useClickAway(dropdownRef, () => setIsDropdownOpen(false));
  const toggleMobileSidebar = () => {
    setIsMobileSidebarOpen(!isMobileSidebarOpen);
  };
  const toggleSubMenu = (menu) => {
    setActiveMenu(activeMenu === menu ? null : menu);
  };
  const toggleDropdown = () => {
    setIsDropdownOpen(!isDropdownOpen);
  };

  const fetchAndsetUserProfile = async () => {
    apiRequest
      .getProfile()
      .then((data) => {
        dispatch(setUserProfile(data?.data?.data));
      })
      .catch((error) => {
        console.log(error);
        
        // authManager.deleteAccessToken();
        // authManager.deleteRole();
        // dispatch(resetUserProfile(null));
        // navigate(LOGIN_ROUTE);
      });
  };

  useEffect(() => {
    if (!userProfile || Object.keys(userProfile).length === 0) {
      fetchAndsetUserProfile();
    }
  }, [dispatch, userProfile]);
  
  if (!userProfile || Object.keys(userProfile).length === 0) {
    return <Loader />;
  }

  const handleLogout = async () => {
    authManager.deleteAccessToken();
    authManager.deleteRole();
    dispatch(resetUserProfile(null));
    navigate(LOGIN_ROUTE);
  };

  return (
    <PartnerAuth>
      <div className="grid grid-cols-1 md:grid-cols-[250px_1fr] h-screen overflow-hidden">
        <div
          className={`fixed md:static top-0 z-50 max-h-screen bg-white shadow-md transition-transform duration-300 flex flex-col h-full border-r w-[250px] ${
            isMobileSidebarOpen ? "translate-x-0" : "-translate-x-full"
          } md:translate-x-0`}
        >
          <div className="flex items-center justify-between p-3">
            <div className="flex items-center h-[18px] space-x-2"></div>
            <button
              onClick={toggleMobileSidebar}
              className="text-black focus:outline-none md:hidden"
            >
              <IoCloseSharp className="text-2xl" />
            </button>
          </div>

          {/* Menu Items */}
          <div className="flex-1 mt-[18px] md:mt-[25px] overflow-y-auto">
            <MenuGroup
              label="Menu"
              activeMenu={activeMenu}
              toggleSubMenu={toggleSubMenu}
              menuItems={[
                {
                  label: "Dashboard",
                  icon: <LuLayoutDashboard />,
                  link: DASHBOARD_ROUTE,
                },
                {
                  label: "Products",
                  icon: <FaRegListAlt />,
                  link: PRODUCTS_ROUTE,
                },
                {
                  label: "My Orders",
                  icon: <GrOrderedList />,
                  link: OREDR_ROUTE,
                },
                {
                  label: "Collection History",
                  icon: <GrOrderedList />,
                  link: COLLECTION_ROUTE,
                },
              ]}
            />
          </div>
        </div>
        <div className="grid grid-cols-1">
          {/* Header */}
          <div
            style={{ zIndex: 56 }}
            className="fixed top-0 left-0 right-[50px] flex items-center px-4 justify-between w-full h-[65px] max-h-[65px] bg-white shadow-md "
          >
            <div className="flex items-center gap-6">
              <FaBars
                className="text-2xl opacity-100 cursor-pointer md:opacity-0"
                onClick={toggleMobileSidebar}
              />
              <Link
                to={DASHBOARD_ROUTE}
                className="flex items-center h-[60px] w-[150px]"
              >
                <img
                  src={LOGO}
                  alt={BRAND_NAME}
                  className="object-contain max-w-full max-h-full"
                />
              </Link>
            </div>

            <div className="flex items-center gap-2">
              <div ref={dropdownRef} className="relative dropdown-container">
                <div
                  className="inline-flex items-center overflow-hidden bg-white cursor-pointer"
                  onClick={toggleDropdown}
                >
                  <div className="flex items-center justify-center px-4 py-2 text-white rounded-full bg-primaryDark w-9 h-9">
                    {"Avinash".slice(0, 1)}
                  </div>
                </div>
                {isDropdownOpen && (
                  <div
                    className="absolute right-0 z-10 mt-2 bg-white rounded-lg shadow-lg w-44"
                    role="menu"
                  >
                    <div className="p-2">
                      <Link
                        to={PROFILE_ROUTE}
                        className="flex items-center w-full gap-2 px-4 py-2 text-sm text-gray-800 rounded-lg hover:bg-primaryDark hover:text-white"
                        role="menuitem"
                      >
                        <CgProfile />
                        My Profile
                      </Link>
                      <button
                        onClick={handleLogout}
                        className="flex items-center w-full gap-2 px-4 py-2 text-sm text-red-700 rounded-lg hover:bg-red-50"
                        role="menuitem"
                      >
                        <FaSignOutAlt />
                        Sign Out
                      </button>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
          <div
            style={{ height: `calc(100vh - 80px)` }}
            className="w-full px-3 pt-5 pb-10 mt-16 overflow-y-scroll"
          >
            {children}
          </div>
        </div>

        {isMobileSidebarOpen && (
          <div
            className="fixed inset-0 z-40 bg-black bg-opacity-50 md:hidden"
            onClick={toggleMobileSidebar}
          ></div>
        )}
      </div>
    </PartnerAuth>
  );
};
const MenuGroup = ({ label, menuItems, activeMenu, toggleSubMenu }) => {
  const location = useLocation();
  const isActive = (link) => location.pathname === link;
  const isSubMenuActive = (subMenus) => {
    return subMenus.some((subMenu) => isActive(subMenu.link));
  };
  return (
    <div>
      <h2 className="px-4 pt-2 pb-2 text-sm text-gray-200 uppercase bg-black">
        {label}
      </h2>
      <ul className="px-2">
        {menuItems.map((item, index) => (
          <React.Fragment key={index}>
            {item.subMenus?.length > 0 ? (
              <li className="relative group">
                <div
                  className={`flex items-center justify-between py-[8px] px-2 text-gray-800 transition-all duration-200 rounded-lg cursor-pointer hover:bg-gray-100 hover:text-black mb-[5px]`}
                  onClick={() => toggleSubMenu(item.label)}
                >
                  <div className="flex items-center space-x-2">
                    <div className="text-sm">{item.icon}</div>
                    <span className="text-sm font-medium">{item.label}</span>
                  </div>
                  <div
                    className={`transition-transform duration-500 ${
                      activeMenu === item.label ||
                      isSubMenuActive(item.subMenus)
                        ? "rotate-180"
                        : "rotate-0"
                    }`}
                  >
                    <FaChevronDown />
                  </div>
                </div>
                {(activeMenu === item.label ||
                  isSubMenuActive(item.subMenus)) && (
                  <ul className="pl-3 mt-1 border-l-4 border-gray-600">
                    {item.subMenus.map((subMenu, subIndex) => {
                      return (
                        <Link to={subMenu.link} key={subIndex}>
                          <li
                            className={`py-[6px] px-2 mb-[5px] text-sm rounded-md hover:bg-gray-100 hover:text-black ${
                              isActive(subMenu.link)
                                ? "bg-gray-100 text-black"
                                : "text-gray-800"
                            }`}
                          >
                            {subMenu.label}
                          </li>
                        </Link>
                      );
                    })}
                  </ul>
                )}
              </li>
            ) : (
              <Link to={item.link}>
                <li
                  className={`relative group mb-[5px] ${
                    isActive(item.link)
                      ? "bg-gray-100 rounded-lg text-black"
                      : "text-gray-800"
                  }`}
                >
                  <div className="flex items-center justify-between mt-[5px] px-2 py-[8px] transition-all duration-200 rounded-lg cursor-pointer hover:bg-gray-100 hover:text-black">
                    <div className="flex items-center space-x-2">
                      <div className="text-sm">{item.icon}</div>
                      <span className="text-sm font-medium">{item.label}</span>
                    </div>
                  </div>
                </li>
              </Link>
            )}
          </React.Fragment>
        ))}
      </ul>
    </div>
  );
};
export default Layout;
